var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 29.1667H27.0836C29.3753 29.1667 31.2503 27.2917 31.2503 25.0001V4.16675H12.5003C9.37531 4.16675 6.64616 5.89589 5.22949 8.43756",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 35.4165C4.16699 38.8748 6.95866 41.6665 10.417 41.6665H12.5003C12.5003 39.3748 14.3753 37.4998 16.667 37.4998C18.9587 37.4998 20.8337 39.3748 20.8337 41.6665H29.167C29.167 39.3748 31.042 37.4998 33.3337 37.4998C35.6253 37.4998 37.5003 39.3748 37.5003 41.6665H39.5837C43.042 41.6665 45.8337 38.8748 45.8337 35.4165V29.1665H39.5837C38.4378 29.1665 37.5003 28.229 37.5003 27.0832V20.8332C37.5003 19.6873 38.4378 18.7498 39.5837 18.7498H42.2711L38.7087 12.5207C37.9587 11.229 36.5837 10.4165 35.0837 10.4165H31.2503V24.9998C31.2503 27.2915 29.3753 29.1665 27.0837 29.1665H25.0003",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 45.8333C18.9679 45.8333 20.8333 43.9679 20.8333 41.6667C20.8333 39.3655 18.9679 37.5 16.6667 37.5C14.3655 37.5 12.5 39.3655 12.5 41.6667C12.5 43.9679 14.3655 45.8333 16.6667 45.8333Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 45.8333C35.6348 45.8333 37.5003 43.9679 37.5003 41.6667C37.5003 39.3655 35.6348 37.5 33.3337 37.5C31.0325 37.5 29.167 39.3655 29.167 41.6667C29.167 43.9679 31.0325 45.8333 33.3337 45.8333Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 25V29.1667H39.5833C38.4375 29.1667 37.5 28.2292 37.5 27.0833V20.8333C37.5 19.6875 38.4375 18.75 39.5833 18.75H42.2708L45.8333 25Z",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 16.6665H16.667",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 22.9165H12.5003",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 29.1665H8.33366",
    stroke: "#EC008C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.84446371022712e800a2f8deea56bc93.svg";
export { ForwardRef as ReactComponent };